import React from 'react';
var DescriptionField = function DescriptionField(_ref) {
  var description = _ref.description,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("span", {
    id: id
  }, description);
};
export default DescriptionField;